/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { styled, kfrm, css } from '@elliemae/ds-system';
import type { TooltipAnimationT, TooltipContainerT } from './index.d';

const showAnimation = kfrm`
    from {
      opacity: 0;
      transform: scale(0.8);
    }

    to {
      opacity: 1;
      transform: scale(1);
      visibility: visible;
    }
`;

const hideAnimation = kfrm`
    0% {
      opacity: 1;
      transform: scale(1);
    }

    100% {
      opacity: 0;
      transform: scale(0.8);
    }
`;

const StyledTooltipContainer = styled.div<TooltipContainerT>`
  &[data-popper-reference-hidden='true'] {
    display: none;
    pointer-events: none;
  }
`;

const StyledAnimatedTooltip = styled.div<TooltipAnimationT>`
  text-align: center;
  min-width: ${({ theme }) => theme.space.l};
  max-width: 250px;
  min-height: 24px;
  padding: ${({ theme }) => `${theme.space.xxxs} ${theme.space.xs}`};
  position: relative;
  background-color: white;
  border-radius: 2px;
  font-size: 13px;
  color: ${({ theme }) => theme.colors.neutral[600]};
  box-shadow:
    0 1px 5px 0 rgb(0 0 0 / 13%),
    0 2px 4px 0 rgb(0 0 0 / 20%);
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2));
  visibility: ${({ showTooltip }) => (showTooltip ? 'visible' : 'hidden')};
  ${({ showTooltip }) => css`
    animation: ${showTooltip ? showAnimation : hideAnimation} 0.1s ease-in;
  `}
  transition: visibility 0.1s ease-in;
`;

const StyledTriggerComponentContainer = styled.div`
  display: inline-block;
`;

const StyledTooltipText = styled.div`
  white-space: normal;
  word-wrap: break-word;
  display: inline-block;
`;

const StyledTooltipArrow = styled.div`
  position: absolute;
  width: 18px;
  height: 18px;
  pointer-events: none;
  background-color: transparent;
  & .stroke {
    fill: white;
  }
  & .fill {
    fill: white;
  }

  &[data-placement^='top'] {
    svg {
      transform: rotateZ(180deg);
    }
    top: 98%;
  }
  &[data-placement^='right'] {
    svg {
      transform: rotateZ(-90deg);
    }
    right: 99.5%;
  }
  &[data-placement^='bottom'] {
    bottom: 97%;
  }
  &[data-placement^='left'] {
    svg {
      transform: rotateZ(90deg);
    }
    left: 99.5%;
  }
`;

export {
  StyledTooltipContainer,
  StyledTriggerComponentContainer,
  StyledTooltipText,
  StyledTooltipArrow,
  StyledAnimatedTooltip,
};
